import { cn } from "@/lib/utils";
import Spinner from "../ui/spinner";

const Loading = ({ className }) => {
  return (
    <div
      className={cn(
        "flex justify-center items-center w-full h-[100vh] bg-commerce-01 text-foreground",
        className
      )}
    >
      <Spinner className="w-16 h-16" />
    </div>
  );
};

export default Loading;
